import { Tabs } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const TabsStyled = styled(Tabs)`
  width: 100%;

  .MuiTabs-indicator {
    background-color: ${COLORS.GREEN};
    height: 3px;
  }

  .MuiTab-root {
    color: ${COLORS.GRAY_2};
    text-transform: none;
    min-width: 64px;
    min-height: 64px;
    padding-left: 12px;
    padding-right: 12px;
  }

  .Mui-selected {
    color: ${COLORS.GREEN};
  }

  .HomeTab {
    font-size: 24px;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      width: 1px;
      height: calc(100% - 24px);
      background: ${COLORS.GRAY_2};
      opacity: 0.6;
    }
  }
`;
